export default __webpack_public_path__ + "static/media/overlordIcon.e38324de.png";